import template from "./proxy-response-default.html";
function Controller($logger) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.pretty = null;
		ctrl.isObject = false;

		if(ctrl.content !== null && ctrl.content !== undefined) {
			if(typeof ctrl.content === "object") {
				ctrl.isObject = true;
				try {
					ctrl.pretty = JSON.stringify(ctrl.content, null, 2);
				}
				catch(e) {
					ctrl.pretty = String(ctrl.content);
				}
			} 
			else if(typeof ctrl.content === "string") {
				try {
					const parsed = JSON.parse(ctrl.content);
					ctrl.isObject = true;
					ctrl.pretty = JSON.stringify(parsed, null, 2);
				}
				catch(e) {
					ctrl.isObject = false;
				}
			}
		}
	};
}

export default angular.module("vesl.components.proxy-response-default", []).component("proxyResponseDefault", {
	bindings: {
		content: "<",
		action: "<"
	},
	controller: Controller,
	template
}).name;
